import styled, { css } from 'styled-components';
var borderStyles = css(["border-radius:", "px;", ""], function (_ref) {
  var small = _ref.small;
  return small ? 3 : 4;
}, function (_ref2) {
  var withRoundedCorners = _ref2.withRoundedCorners;
  return withRoundedCorners ? "border-radius: 50%;" : '';
});
export var IconImage = styled.span.withConfig({
  displayName: "IconImage",
  componentId: "sc-xtz5gr-0"
})(["display:block;position:relative;flex-shrink:0;width:", ";height:", ";", ";", ";img,> svg{width:100%;height:100%;}> svg{position:absolute;top:0;left:0;", ";}img{position:relative;}&,img,> svg{", "}"], function (_ref3) {
  var sizeParam = _ref3.sizeParam;
  return sizeParam ? "".concat(sizeParam, "px") : '36px';
}, function (_ref4) {
  var sizeParam = _ref4.sizeParam;
  return sizeParam ? "".concat(sizeParam, "px") : '36px';
}, function (_ref5) {
  var withBorder = _ref5.withBorder;
  return withBorder ? "border: 1px solid rgba(34, 34, 38, 0.07);" : null;
}, function (_ref6) {
  var margin = _ref6.margin;
  return margin ? "margin: ".concat(margin) : null;
}, function (_ref7) {
  var lightDefaultIcon = _ref7.lightDefaultIcon;
  return lightDefaultIcon ? "opacity: 0.3" : null;
}, borderStyles);